import JSXComponent from "../../../../dist/jsx-render/JSXComponent";
import dom from "../../../../dist/jsx-render/dom";
import { IWidgetComponent } from "./IWidgetComponent";
import { WidgetDashboard } from "../Widgets/WidgetDashboard";
import { LanguageString } from "../../../Model/LanguageString";
import { app } from "../../../Frame/App";
import { ReportConnectionManager } from "../../../Common/ReportConnectionManager";

export type WidgetDashboardComponentProps = {
    widget: WidgetDashboard;
}

export class WidgetDashboardComponent extends JSXComponent implements IWidgetComponent {
    props: WidgetDashboardComponentProps;
    private reportConnectionManager: ReportConnectionManager;

    constructor(props: WidgetDashboardComponentProps) {
        super(props);

        this.reportConnectionManager = new ReportConnectionManager();
        this.reportConnectionManager.init();
    }

    private tabId: string;

    public element: HTMLElement;
    public getElement = (): HTMLElement => {

        let hasTitle = false;
        let titleObj = LanguageString.fromPartial(this.props.widget.props.title);
        if (titleObj.inLanguage?.trim().length) {
            hasTitle = true;
        }

        // Use ReportConnectionManager to free server memory after this report is not displayed anymore.
        this.reportConnectionManager.setReport(this.props.widget.props.reportId, this.tabId);

        window.addEventListener("beforeunload", (event: Event) => {
            console.log("test unload");
            this.reportConnectionManager.manualRemoveConnection();
            console.log("after test unload");
        })


        return <div className="widget Background-Blur-90-MSO widget-dashboard">
            {hasTitle
                ? <div className="title-row">
                    <div className="title mr-auto">{titleObj.inLanguage}</div>
                </div>
                : []}
            
            <div className="content-row">
                <div className="h-100">
                    <iframe id="reportContent" className="report-content" src={app.resolveUrl(`~/Reports/StimulsoftViewer/${this.props.widget.props.reportId}/0/${this.tabId}`)}></iframe>
                </div>
            </div>
        </div>;
    }



    public render(): HTMLElement {
        this.tabId = app.createGuid();

        this.element = this.getElement();
        this.props.widget.setGridPosition();

        return this.element;
    }
}